import docStarDark from 'assets/images/DocStarDark.svg';
import docStarWhite from 'assets/images/DocStarWhite.svg';
import { cn } from 'lib/utils';

type DocStarIconVariant = 'menu' | 'muted';

interface DocStarIconProps {
  className?: string;
  variant?: DocStarIconVariant;
}

function DocStarMutedSvg({ className }: Readonly<{ className?: string }>) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M13.3334 8.00016V3.83252C13.3334 3.72643 13.2913 3.62469 13.2163 3.54967L11.1172 1.45066C11.0422 1.37564 10.9405 1.3335 10.8344 1.3335H3.06675C2.84583 1.3335 2.66675 1.51258 2.66675 1.7335V14.2668C2.66675 14.4878 2.84583 14.6668 3.06675 14.6668H7.33341"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33325 6.66667H10.6666M5.33325 4H7.99992M5.33325 9.33333H7.33325"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8703 11.4089L11.4764 10.1237C11.5542 9.95875 11.779 9.95875 11.8568 10.1237L12.4628 11.4089L13.8182 11.6162C13.9922 11.6428 14.0614 11.8665 13.9356 11.9949L12.955 12.9945L13.1864 14.4067C13.2161 14.588 13.0342 14.7263 12.8786 14.6407L11.6666 13.9735L10.4545 14.6407C10.2989 14.7263 10.117 14.588 10.1468 14.4067L10.3782 12.9945L9.39758 11.9949C9.27171 11.8665 9.34098 11.6428 9.51491 11.6162L10.8703 11.4089Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6667 1.3335V3.60016C10.6667 3.82108 10.8458 4.00016 11.0667 4.00016H13.3334"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function DocStarIcon({ className, variant = 'menu' }: Readonly<DocStarIconProps>) {
  if (variant === 'muted') {
    return <DocStarMutedSvg className={cn('shrink-0', className)} />;
  }

  return (
    <>
      <img
        src={docStarDark}
        alt=""
        aria-hidden="true"
        className={cn('shrink-0 object-contain dark:hidden', className)}
      />
      <img
        src={docStarWhite}
        alt=""
        aria-hidden="true"
        className={cn('hidden shrink-0 object-contain dark:block', className)}
      />
    </>
  );
}
